import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { isDevMode } from '@angular/core';
import * as Sentry from '@sentry/angular';
import posthog from 'posthog-js';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

posthog.init(environment.posthogKey, {
  api_host: environment.posthogHost,
  person_profiles: 'identified_only',
  disable_session_recording: true,
  loaded: (posthog) => {
    if (environment.production) posthog.startSessionRecording();
  },
});

Sentry.init({
  enabled: environment.production,
  dsn: environment.sentryDsn,
});

// Log mode development pour debug Angular DevTools
if (!environment.production && isDevMode()) {
  console.log('Angular is running in development mode - DevTools should be available');
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
